import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import './LandingPage.css';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.weotp.app&hl=en_IN';
const APP_STORE_URL = 'https://apps.apple.com/in/app/id6758047052';

/* ---------------------------------- icons --------------------------------- */

const Icon = ({ path, size = 24, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
  >
    {path}
  </svg>
);

const IconHotel = (props) => (
  <Icon
    {...props}
    path={
      <>
        <path d="M3 21h18" />
        <path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16" />
        <path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2" />
      </>
    }
  />
);

const IconSpa = (props) => (
  <Icon
    {...props}
    path={
      <>
        <path d="M12 21c0-4.5-2.5-8-7-9 4.5-1 7 2 7 4.5 0-2.5 2.5-5.5 7-4.5-4.5 1-7 4.5-7 9Z" />
        <path d="M12 13c-2-2.5-2-6 0-9 2 3 2 6.5 0 9Z" />
      </>
    }
  />
);

const IconTour = (props) => (
  <Icon
    {...props}
    path={
      <>
        <path d="m4 7 8-4 8 4-8 4-8-4Z" />
        <path d="M4 12l8 4 8-4" />
        <path d="M4 17l8 4 8-4" />
      </>
    }
  />
);

const IconPackage = (props) => (
  <Icon
    {...props}
    path={
      <>
        <path d="M17.8 19.2 16 11l3.5-3.5a2.1 2.1 0 0 0-3-3L13 8 4.8 6.2a.7.7 0 0 0-.7 1.1L7 10l-2 2-2-.5a.6.6 0 0 0-.6 1l2.3 2.3L7 17l.2 2.3a.6.6 0 0 0 1 .4l2-2 2.7 2.9a.7.7 0 0 0 1.1-.7Z" />
      </>
    }
  />
);

const IconSearch = (props) => (
  <Icon {...props} path={<><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></>} />
);

const IconCompare = (props) => (
  <Icon
    {...props}
    path={
      <>
        <path d="M3 6h7M14 6h7M3 18h7M14 18h7" />
        <circle cx="8" cy="6" r="2.5" />
        <circle cx="16" cy="18" r="2.5" />
      </>
    }
  />
);

const IconChat = (props) => (
  <Icon
    {...props}
    path={<path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9 9 0 0 1-3.3-.6L3 21l1.7-5a8.2 8.2 0 0 1-.7-3.4 8.4 8.4 0 0 1 9-8.4 8.4 8.4 0 0 1 8 7.3Z" />}
  />
);

const IconShield = (props) => (
  <Icon
    {...props}
    path={<><path d="M12 22s8-3.5 8-9.5V5.5L12 2 4 5.5V12.5C4 18.5 12 22 12 22Z" /><path d="m9 12 2 2 4-4" /></>}
  />
);

const IconTag = (props) => (
  <Icon
    {...props}
    path={<><path d="M20.6 13.4 12 22l-9-9V4h9l8.6 8.6a1.9 1.9 0 0 1 0 2.8Z" /><circle cx="7.5" cy="7.5" r="1.3" /></>}
  />
);

const IconHeart = (props) => (
  <Icon
    {...props}
    path={<path d="M20.3 5.7a5 5 0 0 0-7.1 0L12 6.9l-1.2-1.2a5 5 0 1 0-7.1 7.1l8.3 8.3 8.3-8.3a5 5 0 0 0 0-7.1Z" />}
  />
);

const IconPin = (props) => (
  <Icon
    {...props}
    path={<><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" /></>}
  />
);

const IconMail = (props) => (
  <Icon {...props} path={<><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></>} />
);

const IconPhone = (props) => (
  <Icon
    {...props}
    path={<path d="M21 16.9v2.6a1.5 1.5 0 0 1-1.7 1.5A18.8 18.8 0 0 1 3 4.7 1.5 1.5 0 0 1 4.5 3h2.6a1.5 1.5 0 0 1 1.5 1.3c.1 1 .4 1.9.7 2.8a1.5 1.5 0 0 1-.4 1.6L7.8 9.8a15 15 0 0 0 6.4 6.4l1.1-1.1a1.5 1.5 0 0 1 1.6-.4c.9.3 1.8.6 2.8.7A1.5 1.5 0 0 1 21 16.9Z" />}
  />
);

const IconApple = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.4 12.7c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.15-2.8.85-3.5.85s-1.8-.83-3-.81a4.4 4.4 0 0 0-3.7 2.25c-1.6 2.75-.4 6.8 1.1 9 .75 1.1 1.65 2.3 2.8 2.26 1.1-.05 1.55-.72 2.9-.72s1.75.72 2.95.7c1.2-.02 2-1.1 2.75-2.2a9.6 9.6 0 0 0 1.25-2.55c-.03-.01-2.4-.92-2.4-3.65ZM14.2 5.9c.6-.75 1-1.78.9-2.8-.87.03-1.93.58-2.56 1.3-.56.65-1.05 1.7-.92 2.7.97.08 1.96-.5 2.58-1.2Z" />
  </svg>
);

const IconPlay = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M3.9 2.3c-.3.3-.5.8-.5 1.4v16.6c0 .6.2 1.1.5 1.4l.1.1 9.3-9.3v-.2L3.9 2.3ZM16.5 15.4l-3.1-3.1 3.1-3.1 3.7 2.1c1.1.6 1.1 1.6 0 2.2l-3.7 1.9ZM13.4 12.3l-9.2 9.2c.4.4 1 .4 1.7 0l11-6.2-3.5-3ZM5.9 2.4c-.7-.4-1.3-.4-1.7 0l9.2 9.2 3.5-3L5.9 2.4Z" />
  </svg>
);

const IconStar = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="m12 2 3 6.6 7 .8-5.2 4.8 1.4 7L12 17.8 5.8 21.2l1.4-7L2 9.4l7-.8L12 2Z" />
  </svg>
);

const IconMenu = (props) => (
  <Icon {...props} path={<><path d="M4 7h16M4 12h16M4 17h16" /></>} />
);

const IconClose = (props) => (
  <Icon {...props} path={<><path d="M6 6l12 12M18 6 6 18" /></>} />
);

/* ------------------------------- page content ------------------------------ */

const CATEGORIES = [
  {
    key: 'hotels',
    Icon: IconHotel,
    title: 'Hotels',
    text: 'Budget rooms to beach resorts, with photos, amenities and room-wise pricing before you decide.',
  },
  {
    key: 'spas',
    Icon: IconSpa,
    title: 'Spas & Wellness',
    text: 'Massages, therapies and day packages, with timings and service menus laid out clearly.',
  },
  {
    key: 'tours',
    Icon: IconTour,
    title: 'Tours & Activities',
    text: 'Treks, sightseeing and day experiences, with options and slots you can compare side by side.',
  },
  {
    key: 'packages',
    Icon: IconPackage,
    title: 'Travel Packages',
    text: 'Curated holidays with day-by-day itineraries, inclusions and variants for every budget.',
  },
];

const STEPS = [
  {
    Icon: IconSearch,
    title: 'Search where you are going',
    text: 'Pick a destination or use your location. We sort by real distance, not guesswork.',
  },
  {
    Icon: IconCompare,
    title: 'Compare openly',
    text: 'Rooms, services and prices are shown up front — no hidden totals at the last step.',
  },
  {
    Icon: IconChat,
    title: 'Chat on WhatsApp',
    text: 'Message the property directly with your dates and details, and settle it in one conversation.',
  },
];

const BENEFITS = [
  {
    Icon: IconShield,
    title: 'Verified listings',
    text: 'Verified properties carry a badge, so you know who has been checked.',
  },
  {
    Icon: IconTag,
    title: 'No booking fees',
    text: 'You talk to the property directly. We never add a commission on top of their price.',
  },
  {
    Icon: IconHeart,
    title: 'Save what you like',
    text: 'Build a wishlist across hotels, spas, tours and packages, then come back to it later.',
  },
  {
    Icon: IconPin,
    title: 'Curated destinations',
    text: 'Hand-picked places to start from when you know you want to travel, but not where.',
  },
];

/* ---------------------------------- page ---------------------------------- */

const LandingPage = () => {
  const { settings, companyName: ctxName, logoUrl } = useSettings();

  const companyName = ctxName || settings?.company?.name || 'We OTP';
  const email = settings?.company?.email;
  const phone = settings?.company?.phone;
  const address = settings?.company?.address;
  const copyrightText = settings?.company?.copyright?.trim();
  const currentYear = new Date().getFullYear();
  const copyright = copyrightText || `© ${currentYear} ${companyName}. All rights reserved.`;

  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Anchor navigation without turning on smooth scrolling app-wide
  const scrollToSection = (event, id) => {
    event.preventDefault();
    setMenuOpen(false);
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const storeButtons = (variant = 'light') => (
    <div className={`lp-stores lp-stores-${variant}`}>
      <a className="lp-store" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
        <IconPlay />
        <span>
          <small>Get it on</small>
          Google Play
        </span>
      </a>
      <a className="lp-store" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
        <IconApple />
        <span>
          <small>Download on the</small>
          App Store
        </span>
      </a>
    </div>
  );

  return (
    <div className="lp">
      {/* ------------------------------- header ------------------------------ */}
      <header className={`lp-header ${scrolled ? 'is-scrolled' : ''}`}>
        <div className="lp-container lp-header-inner">
          <a className="lp-brand" href="#top" onClick={(e) => scrollToSection(e, 'top')}>
            {logoUrl ? (
              <img src={logoUrl} alt={companyName} className="lp-brand-logo" />
            ) : (
              <span className="lp-brand-mark" aria-hidden="true">W</span>
            )}
            <span className="lp-brand-name">{companyName}</span>
          </a>

          <nav className={`lp-nav ${menuOpen ? 'is-open' : ''}`}>
            <a href="#explore" className="lp-nav-link" onClick={(e) => scrollToSection(e, 'explore')}>
              Explore
            </a>
            <a href="#how" className="lp-nav-link" onClick={(e) => scrollToSection(e, 'how')}>
              How it works
            </a>
            <a href="#partners" className="lp-nav-link" onClick={(e) => scrollToSection(e, 'partners')}>
              For partners
            </a>
            <Link to="/list-your-property" className="lp-nav-link" onClick={() => setMenuOpen(false)}>
              List your property
            </Link>
            <Link to="/owner" className="lp-nav-link" onClick={() => setMenuOpen(false)}>
              Partner login
            </Link>
            <a
              className="lp-btn lp-btn-primary lp-nav-cta"
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Get the app
            </a>
          </nav>

          <button
            type="button"
            className="lp-menu-btn"
            onClick={() => setMenuOpen((open) => !open)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
          >
            {menuOpen ? <IconClose size={22} /> : <IconMenu size={22} />}
          </button>
        </div>
      </header>

      <main id="top">
        {/* -------------------------------- hero ------------------------------ */}
        <section className="lp-hero">
          <div className="lp-hero-glow lp-hero-glow-a" aria-hidden="true" />
          <div className="lp-hero-glow lp-hero-glow-b" aria-hidden="true" />

          <div className="lp-container lp-hero-inner">
            <div className="lp-hero-copy">
              <span className="lp-pill">Hotels · Spas · Tours · Travel</span>
              <h1 className="lp-hero-title">
                Book Hotel - Tour and Travel package on WeOtp
              </h1>
              <p className="lp-hero-sub">
                WeOtp is an online hotel booking and travel platform that connects customers with
                hotels and travel services. We offer hotel bookings, tour packages, and tour &amp;
                travel solutions at convenient prices. Our goal is to make travel simple, affordable,
                and hassle-free by providing customers with reliable options and a smooth booking
                experience.
              </p>

              {storeButtons('light')}

              <ul className="lp-trust">
                <li>
                  <IconShield size={17} /> Verified properties
                </li>
                <li>
                  <IconTag size={17} /> Zero booking fees
                </li>
                <li>
                  <IconChat size={17} /> Direct WhatsApp chat
                </li>
              </ul>
            </div>

            {/* CSS-only app preview */}
            <div className="lp-hero-visual" aria-hidden="true">
              <div className="lp-phone">
                <div className="lp-phone-notch" />
                <div className="lp-phone-screen">
                  <div className="lp-app-bar">
                    <span className="lp-app-where">Goa, India</span>
                    <span className="lp-app-dates">12 – 15 Nov · 2 guests</span>
                  </div>

                  <div className="lp-app-chips">
                    <span className="is-active">Hotels</span>
                    <span>Spas</span>
                    <span>Tours</span>
                    <span>Packages</span>
                  </div>

                  <div className="lp-app-card">
                    <div className="lp-app-thumb">
                      <span className="lp-app-badge">
                        <IconShield size={11} /> Verified
                      </span>
                    </div>
                    <div className="lp-app-body">
                      <div className="lp-app-row">
                        <strong>Blue Lagoon Resort</strong>
                        <span className="lp-app-rating">
                          <IconStar /> 4.8
                        </span>
                      </div>
                      <span className="lp-app-meta">Candolim Beach · 1.2 km away</span>
                      <div className="lp-app-price">
                        <b>₹2,500</b>
                        <s>₹3,200</s>
                        <span>/ night</span>
                      </div>
                    </div>
                  </div>

                  <div className="lp-app-card is-dim">
                    <div className="lp-app-thumb lp-app-thumb-alt" />
                    <div className="lp-app-body">
                      <div className="lp-app-row">
                        <strong>Serenity Spa</strong>
                        <span className="lp-app-rating">
                          <IconStar /> 4.6
                        </span>
                      </div>
                      <span className="lp-app-meta">Calangute · 2.4 km away</span>
                      <div className="lp-app-price">
                        <b>₹1,500</b>
                        <span>/ session</span>
                      </div>
                    </div>
                  </div>

                  <div className="lp-app-cta">
                    <IconChat size={16} /> Chat on WhatsApp
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lp-hero-wave" aria-hidden="true" />
        </section>

        {/* ------------------------------ categories --------------------------- */}
        <section className="lp-section" id="explore">
          <div className="lp-container">
            <header className="lp-section-head">
              <span className="lp-eyebrow">Explore</span>
              <h2>Four ways to plan your trip</h2>
              <p>
                Everything in one app — whether you need a bed for the night, an afternoon of
                calm, or a full week planned for you.
              </p>
            </header>

            <div className="lp-grid lp-grid-4">
              {CATEGORIES.map(({ key, Icon: CardIcon, title, text }) => (
                <article className="lp-card" key={key}>
                  <span className="lp-card-icon">
                    <CardIcon size={22} />
                  </span>
                  <h3>{title}</h3>
                  <p>{text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ------------------------------ how it works ------------------------- */}
        <section className="lp-section lp-section-alt" id="how">
          <div className="lp-container">
            <header className="lp-section-head">
              <span className="lp-eyebrow">How it works</span>
              <h2>Three steps, one conversation</h2>
              <p>
                We help you find the right place and then get out of the way — you deal with the
                property itself.
              </p>
            </header>

            <ol className="lp-steps">
              {STEPS.map(({ Icon: StepIcon, title, text }, index) => (
                <li className="lp-step" key={title}>
                  <span className="lp-step-num">{index + 1}</span>
                  <span className="lp-step-icon">
                    <StepIcon size={22} />
                  </span>
                  <h3>{title}</h3>
                  <p>{text}</p>
                </li>
              ))}
            </ol>
          </div>
        </section>

        {/* ------------------------------- benefits ---------------------------- */}
        <section className="lp-section">
          <div className="lp-container">
            <header className="lp-section-head">
              <span className="lp-eyebrow">Why {companyName}</span>
              <h2>Built to be straightforward</h2>
            </header>

            <div className="lp-grid lp-grid-4">
              {BENEFITS.map(({ Icon: BenefitIcon, title, text }) => (
                <article className="lp-benefit" key={title}>
                  <span className="lp-benefit-icon">
                    <BenefitIcon size={20} />
                  </span>
                  <div>
                    <h3>{title}</h3>
                    <p>{text}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ------------------------------- partners ---------------------------- */}
        <section className="lp-section" id="partners">
          <div className="lp-container">
            <div className="lp-partner">
              <div className="lp-partner-copy">
                <span className="lp-eyebrow lp-eyebrow-light">For property owners</span>
                <h2>Put your property in front of travellers</h2>
                <p>
                  Hotels, spas, tour operators and travel agencies can list for free. Verify your
                  phone with an OTP, add your details and photos, and our team reviews it before it
                  goes live. Enquiries come straight to your WhatsApp.
                </p>
                <ul className="lp-partner-points">
                  <li>Free to list — no commission on your bookings</li>
                  <li>Verified and featured placement available</li>
                  <li>You keep full control of pricing and availability</li>
                </ul>
                <div className="lp-partner-actions">
                  <Link to="/list-your-property" className="lp-btn lp-btn-light">
                    List your property
                  </Link>
                  <a
                    href="#explore"
                    className="lp-btn lp-btn-ghost"
                    onClick={(e) => scrollToSection(e, 'explore')}
                  >
                    See what we cover
                  </a>
                </div>
              </div>

              <div className="lp-partner-steps" aria-hidden="true">
                <div className="lp-mini-step">
                  <span>1</span> Verify your phone with an OTP
                </div>
                <div className="lp-mini-step">
                  <span>2</span> Choose hotel, spa, tour or package
                </div>
                <div className="lp-mini-step">
                  <span>3</span> Add details, photos and pricing
                </div>
                <div className="lp-mini-step is-final">
                  <span>4</span> We review, then you go live
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ------------------------------- download ---------------------------- */}
        <section className="lp-section lp-section-alt">
          <div className="lp-container">
            <div className="lp-download">
              <div>
                <span className="lp-eyebrow">Get the app</span>
                <h2>Plan your next trip from your pocket</h2>
                <p>
                  Search nearby, save favourites and reach any property in a couple of taps.
                  Available on Android and iPhone.
                </p>
              </div>
              {storeButtons('dark')}
            </div>
          </div>
        </section>
      </main>

      {/* -------------------------------- footer ------------------------------ */}
      <footer className="lp-footer">
        <div className="lp-container lp-footer-inner">
          <div className="lp-footer-brand">
            <div className="lp-brand">
              {logoUrl ? (
                <img src={logoUrl} alt={companyName} className="lp-brand-logo" />
              ) : (
                <span className="lp-brand-mark" aria-hidden="true">W</span>
              )}
              <span className="lp-brand-name">{companyName}</span>
            </div>
            <p>Hotels, spas, tours and travel packages — discovered in one place.</p>
            {storeButtons('footer')}
          </div>

          <div className="lp-footer-col">
            <h4>Explore</h4>
            <a href="#explore" onClick={(e) => scrollToSection(e, 'explore')}>Categories</a>
            <a href="#how" onClick={(e) => scrollToSection(e, 'how')}>How it works</a>
            <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">Android app</a>
            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">iPhone app</a>
          </div>

          <div className="lp-footer-col">
            <h4>For partners</h4>
            <Link to="/list-your-property">List your property</Link>
            <Link to="/owner">Partner login</Link>
            <a href="#partners" onClick={(e) => scrollToSection(e, 'partners')}>How listing works</a>
            <Link to="/sy-admin/login">Admin login</Link>
          </div>

          <div className="lp-footer-col">
            <h4>Contact</h4>
            {email && (
              <a href={`mailto:${email}`}>
                <IconMail size={15} /> {email}
              </a>
            )}
            {phone && (
              <a href={`tel:${phone}`}>
                <IconPhone size={15} /> {phone}
              </a>
            )}
            {address && (
              <span className="lp-footer-address">
                <IconPin size={15} /> {address}
              </span>
            )}
          </div>
        </div>

        <div className="lp-container lp-footer-bottom">
          <p>{copyright}</p>
          <div className="lp-footer-legal">
            <Link to="/page/privacy-policy">Privacy Policy</Link>
            <Link to="/page/terms-and-conditions">Terms &amp; Conditions</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
